import { render, staticRenderFns } from "./RD.vue?vue&type=template&id=af3d3410"
import script from "./RD.vue?vue&type=script&lang=js"
export * from "./RD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports